import React from 'react';
import { Flex, Heading, Spacer, HStack, Spinner, Text } from '@chakra-ui/react';

import ClientSearchBar from 'sharedComponents/ClientSearchBar';

interface InfoViewHeaderProps {
  title: string;
  HeaderButton: JSX.Element;
  loadingMessage?: string;
}

function InfoViewHeader(props: InfoViewHeaderProps): JSX.Element {
  const { title, HeaderButton, loadingMessage } = props;

  return (
    <Flex
      background="brand.headerGradient"
      borderRadius={8}
      shrink={0}
      height={20}
      marginY="0"
      paddingX={8}
      marginBottom={4}
    >
      <HStack width="100%" paddingY={6}>
        <Heading
          size="lg"
          fontWeight="normal"
          minWidth="185px"
          marginRight="auto"
          textAlign="left"
          paddingRight={8}
          color="brand.white"
        >
          {title}
        </Heading>

        {loadingMessage && (
          <HStack spacing={2} color="brand.white" minWidth="150px">
            <Spinner size="sm" thickness="2px" />
            <Text fontSize="sm" whiteSpace="nowrap">
              {loadingMessage}
            </Text>
          </HStack>
        )}

        <ClientSearchBar />
        <Spacer />
        {HeaderButton}
      </HStack>
    </Flex>
  );
}

InfoViewHeader.defaultProps = {
  loadingMessage: undefined,
};

export default InfoViewHeader;
